import React, {useCallback} from 'react'
import {useIntl} from 'react-intl'

import {BottomSheet} from '@vio/atlas/BottomSheet'
import {useDeviceLayout} from '@vio/atlas/context/deviceLayout'
import {Text} from '@vio/atlas/Text'
import {useBrandCapabilities} from '@vio/core/src/_web/brand/hooks/useBrandCapabilities'
import FormattedMessageWrapper from '@vio/core/src/localization/components/FormattedMessage'

export const CashbackInfoBottomSheet = ({
  isOpen,
  onClose,
  value
}: {
  isOpen: boolean
  onClose: () => void
  value: number
}) => {
  const {formatMessage, formatNumber} = useIntl()
  const {isDesktop} = useDeviceLayout()
  const {
    monetisation: {cashback}
  } = useBrandCapabilities()

  const handleClose = useCallback(() => {
    onClose()
  }, [onClose])

  // Don't render on desktop (tooltip is used instead), when closed, or when
  // the brand has cashback disabled (parent should already gate, but the
  // discriminated union forces the check before reading config.messages).
  if (isDesktop || !isOpen || !cashback.enabled) {
    return null
  }

  const infoTitle = formatMessage(cashback.config.messages.cashbackInfoTitle!, {
    value: formatNumber(value / 100, {style: 'percent'})
  })
  const infoContentMessage = cashback.config.messages.cashbackInfoContent!

  return (
    <BottomSheet
      isOpen={isOpen}
      onClose={handleClose}
      navBarProps={{
        centerContent: infoTitle
      }}
    >
      <Text variant="bodyM">
        <FormattedMessageWrapper {...infoContentMessage} />
      </Text>
    </BottomSheet>
  )
}
